import { useState, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useAuth } from '../contexts/AuthContext';

function useApi() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { logout } = useAuth();
  const baseApiUrl = process.env.REACT_APP_API_URL;

  const sendRequest = useCallback(async (apiUrl, method = 'GET', payload = {}, doLoading = true, customHeaders = {}) => {
    doLoading && setLoading(true);
    setError(null);
    try {
      const authToken = localStorage.getItem('authToken'); // Get token from localStorage

      const response = await axios({
        url: baseApiUrl + apiUrl,
        method,
        data: method !== 'GET' ? payload : undefined,
        params: method === 'GET' ? payload : undefined,
        headers: {
          Authorization: authToken ? `Bearer ${authToken}` : '',
          'Content-Type': 'application/json',
          'ngrok-skip-browser-warning': 'true',
          ...customHeaders,
        },
      });

      setData(response);
      return response;
    } catch (err) {
      setError(err);
      if (err?.response?.status === 401) {
        logout();
        toast.error("Session expired. Please login again.");
      } else {
        const errorMessage = err?.response?.data?.message || "Something went wrong!";
        toast.error(errorMessage);
      }
      throw err;
    } finally {
      setLoading(false);
    }
  }, [logout, baseApiUrl]);

  return { data, loading, error, sendRequest };
}

export default useApi;
